import {
  VENDOR_PRO_UPDATE_REQUEST,
  VENDOR_PRO_UPDATE_SUCCESS,
  VENDOR_PRO_UPDATE_FAIL,
} from "../constants/AuthConstant";

const initialState = {
  loading: false,
  result: [],
  msg: "",
  error: "",
};

const VendorProReducer = (state = initialState, action) => {
  switch (action.type) {
    case VENDOR_PRO_UPDATE_REQUEST:
      return {
        ...state,
        loading: action.payload,
      };
    case VENDOR_PRO_UPDATE_SUCCESS:
      return {
        ...state,
        result: action.result.data,
        loading: action.payload,
        msg: action.msg,
      };
    case VENDOR_PRO_UPDATE_FAIL:
      return {
        ...state,
        error: action.error,
        loading: action.payload,
        msg: action.msg,
      };

    default:
      return state;
  }
};

export default VendorProReducer;
